import React from 'react';
import Gallery from '../components/Gallery';
import { fashionShootImages } from '../data/images';

const FashionShoot = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Fashion Shoots</h1>
          <p>
            Professional fashion photography that showcases style, elegance, and personality with stunning visual impact. 
            From editorial shoots to commercial fashion, we create captivating visual narratives.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={fashionShootImages} sectionId="fashion-shoot" />
        </div>
      </section>

    </div>
  );
};

export default FashionShoot;
